export enum FEATURES {
  CONSENT_FORM = 'consentForm',
}

export const FEATURE_FLAGS = [{ name: FEATURES.CONSENT_FORM, isActive: false }];

export const flagActive = (feature: string) => {
  return FEATURE_FLAGS.find(({ name }) => name === feature)?.isActive;
};

export const STUDY_REC = 'North East -Tyne & Wear South Research Ethics Committee';
export const STUDY_REF = '19/NE/0020';
export const STUDY_URL = 'www.discovermestudy.com';
export const STUDY_FULL_URL = 'https://www.discovermestudy.com';
export const STUDY_EMAIL = 'uk@discovermestudy.com';
export const DPO_EMAIL = 'dpo@omnigenbiodata.co.uk';
export const OMNIGEN_PRIVACY_URL = 'https://www.omnigenbiodata.co.uk/?privacy=true';

export const STUDY_TEL = '020 3866 8941';
export const COMPANY_NUMBER = '10565653';
export const STUDY_ADDRESS =
  'FAO Discover Me UK, Omnigen Biodata Ltd, 11 Hope Street Yard, Hope Street, Cambridge CB1 3NA';

export const TRANSLATION_VARS = {
  rec: STUDY_REC,
  studyRef: STUDY_REF,
  companyNumber: COMPANY_NUMBER,
  friendlyUrl: STUDY_URL,
  fullUrl: STUDY_FULL_URL,
  studyTel: STUDY_TEL,
  studyEmail: STUDY_EMAIL,
  studyAddress: STUDY_ADDRESS,
  dpoEmail: DPO_EMAIL,
  omnigenPrivacyUrl: OMNIGEN_PRIVACY_URL,
};
